/* blog-newsletter.js — extracted from sections/blog-newsletter.liquid.
   Bind once even if multiple newsletter sections (or hot-reloads during
   Customizer edits) mount the script tag on the same page. */
(function () {
  if (window.__blogNewsletterBound) return;
  window.__blogNewsletterBound = true;

  document.addEventListener('click', function (e) {
    var expand = e.target.closest('[data-blog-newsletter-expand]');
    if (expand) {
      var extra = expand.parentElement.querySelector('[data-blog-newsletter-extra]');
      if (extra) {
        extra.classList.toggle('blog-newsletter__extra--open');
        expand.setAttribute('aria-expanded', extra.classList.contains('blog-newsletter__extra--open'));
      }
      return;
    }

    var copy = e.target.closest('[data-blog-newsletter-copy]');
    if (copy) {
      navigator.clipboard.writeText(window.location.href);
      copy.classList.add('blog-newsletter__copy-link--copied');
      setTimeout(function () { copy.classList.remove('blog-newsletter__copy-link--copied'); }, 1000);
      return;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-blog-newsletter-form]');
    if (!form) return;
    e.preventDefault();

    var section = form.closest('.blog-newsletter');
    var endpoint = section ? section.getAttribute('data-endpoint') : null;
    if (!endpoint) return;

    var data = new FormData(form);
    var body = {};
    data.forEach(function (v, k) { if (v) body[k] = v; });

    var successEl = form.querySelector('[data-blog-newsletter-success]');
    var errorEl = form.querySelector('[data-blog-newsletter-error]');
    var fieldsEl = form.querySelector('.blog-newsletter__fields');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) {
          if (fieldsEl) fieldsEl.style.display = 'none';
          if (successEl) successEl.style.display = '';
        } else {
          if (errorEl) {
            errorEl.textContent = res.data.detail || 'Something went wrong.';
            errorEl.style.display = '';
          }
        }
      })
      .catch(function () {
        if (errorEl) {
          errorEl.textContent = 'Connection error. Please try again.';
          errorEl.style.display = '';
        }
      });
  });
})();
